import React from 'react';

interface IPropButtonSwitchFilter {
  text: string;
  class: string;
  actionOnClick: () => void;
}

function ButtonSwitchFilter(props: IPropButtonSwitchFilter) {
  return (
    <button
      type="button"
      onClick={props.actionOnClick}
      className={props.class}
      style={{ width: '15rem', margin: '0 1rem 0 0.25rem' }}>
      {props.text}
    </button>
  );
}

export default ButtonSwitchFilter;
